<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'bundles.subtitle' | t }}</p>
    </div>
    <button class="ct-btn ct-btn-primary" type="button" (click)="openCreate()">
      {{ 'bundles.new' | t }}
    </button>
  </div>

  <div class="filters">
    <select
      class="ct-select"
      [ngModel]="filterBrandId()"
      (ngModelChange)="filterBrandId.set($event); onFilterChange()"
      name="filterBrand"
    >
      <option value="">{{ 'portal.catalog.allBrands' | t }}</option>
      @for (brand of brandOptions(); track brand.id) {
        <option [value]="brand.id">{{ brand.name }}</option>
      }
    </select>
    <select
      class="ct-select"
      [ngModel]="filterCategoryId()"
      (ngModelChange)="filterCategoryId.set($event); onFilterChange()"
      name="filterCategory"
    >
      <option value="">{{ 'portal.catalog.allCategories' | t }}</option>
      @for (cat of categoryOptions(); track cat.id) {
        <option [value]="cat.id">{{ cat.label }}</option>
      }
    </select>
  </div>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th>{{ 'common.name' | t }}</th>
          <th>{{ 'portal.catalog.brand' | t }}</th>
          <th>{{ 'products.category' | t }}</th>
          <th class="col-price">{{ 'products.price' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr><td colspan="6">{{ 'common.loading' | t }}</td></tr>
        } @else if (items().length === 0) {
          <tr><td colspan="6">{{ 'bundles.empty' | t }}</td></tr>
        } @else {
          @for (item of items(); track item.id) {
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.brandName ?? '—' }}</td>
              <td>{{ item.categoryName ?? '—' }}</td>
              <td class="col-price">{{ money(item.price) }}</td>
              <td class="col-status">
                <span class="ct-badge" [class.ct-badge-success]="item.isActive" [class.ct-badge-muted]="!item.isActive">
                  {{ (item.isActive ? 'common.active' : 'common.inactive') | t }}
                </span>
              </td>
              <td class="actions">
                <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(item)">
                  {{ 'common.edit' | t }}
                </button>
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="remove(item)">
                  {{ 'common.delete' | t }}
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</section>

@if (dialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDialog()">
    <div class="ct-dialog wide" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingId() ? 'bundles.edit' : 'bundles.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="name">{{ 'common.name' | t }}</label>
            <input id="name" class="ct-input" formControlName="name" (input)="onNameChange($any($event.target).value)" />
          </div>
          <div class="ct-field">
            <label for="slug">{{ 'common.slug' | t }}</label>
            <input id="slug" class="ct-input" formControlName="slug" />
          </div>
          <div class="ct-field">
            <label for="brandId">{{ 'portal.catalog.brand' | t }}</label>
            <select id="brandId" class="ct-select" formControlName="brandId">
              @for (brand of brands(); track brand.id) {
                <option [value]="brand.id">{{ brand.name }}</option>
              }
            </select>
          </div>
          <div class="ct-field">
            <label for="categoryId">{{ 'products.category' | t }}</label>
            <select
              id="categoryId"
              class="ct-select"
              formControlName="categoryId"
              (change)="onCategoryChange()"
            >
              @for (cat of leafCategories(); track cat.id) {
                <option [value]="cat.id">{{ cat.name }}</option>
              }
            </select>
          </div>
          <div class="ct-field">
            <label for="price">{{ 'products.price' | t }}</label>
            <input id="price" class="ct-input" type="number" step="0.01" formControlName="price" />
          </div>
          <div class="ct-field">
            <label for="compareAtPrice">{{ 'products.compareAtPrice' | t }}</label>
            <input id="compareAtPrice" class="ct-input" type="number" step="0.01" formControlName="compareAtPrice" />
          </div>
          <div class="ct-field full">
            <label for="description">{{ 'products.description' | t }}</label>
            <textarea id="description" class="ct-input" rows="6" formControlName="description"></textarea>
            <p class="hint">{{ 'products.descriptionHint' | t }}</p>
          </div>
          <div class="ct-field">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>

        <div class="section">
          <h3>{{ 'bundles.packProducts' | t }}</h3>
          <p class="hint">{{ 'bundles.packProductsHint' | t }}</p>

          <div class="picker">
            <div class="ct-field">
              <label for="productSearch">{{ 'bundles.searchProducts' | t }}</label>
              <input
                id="productSearch"
                class="ct-input"
                [ngModel]="productSearch()"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onProductSearch($event)"
                [placeholder]="'bundles.searchProductsPlaceholder' | t"
              />
            </div>

            <div class="picker__results">
              @if (productsLoading()) {
                <p class="empty">{{ 'common.loading' | t }}</p>
              } @else if (availableProductResults().length === 0) {
                <p class="empty">{{ 'bundles.noProductResults' | t }}</p>
              } @else {
                @for (product of availableProductResults(); track product.id) {
                  <div class="picker__row">
                    <div>
                      <strong>{{ product.name }}</strong>
                      <small>{{ product.sku }} · {{ money(product.price) }}</small>
                    </div>
                    <div class="picker__actions">
                      <button
                        class="ct-btn ct-btn-ghost ct-btn-sm"
                        type="button"
                        (click)="addProduct(product, 'required')"
                      >
                        {{ 'bundles.addRequired' | t }}
                      </button>
                      <button
                        class="ct-btn ct-btn-ghost ct-btn-sm"
                        type="button"
                        (click)="addProduct(product, 'optional')"
                      >
                        {{ 'bundles.addOptional' | t }}
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>

          <div class="pack-lists">
            <div class="pack-list">
              <h4>{{ 'bundles.required' | t }}</h4>
              @if (requiredProducts().length === 0) {
                <p class="empty">{{ 'bundles.noRequired' | t }}</p>
              } @else {
                @for (product of requiredProducts(); track product.productId) {
                  <div class="chip">
                    <div>
                      <strong>{{ product.name }}</strong>
                      <small>{{ product.sku }} · {{ money(product.price) }}</small>
                    </div>
                    <div class="chip__actions">
                      <button
                        class="ct-btn ct-btn-ghost ct-btn-sm"
                        type="button"
                        (click)="moveProduct(product.productId, 'required')"
                      >
                        {{ 'bundles.makeOptional' | t }}
                      </button>
                      <button
                        class="ct-btn ct-btn-danger ct-btn-sm"
                        type="button"
                        (click)="removeProduct(product.productId, 'required')"
                      >
                        {{ 'common.delete' | t }}
                      </button>
                    </div>
                  </div>
                }
              }
            </div>

            <div class="pack-list">
              <h4>{{ 'bundles.optional' | t }}</h4>
              @if (optionalProducts().length === 0) {
                <p class="empty">{{ 'bundles.noOptional' | t }}</p>
              } @else {
                @for (product of optionalProducts(); track product.productId) {
                  <div class="chip">
                    <div>
                      <strong>{{ product.name }}</strong>
                      <small>{{ product.sku }} · {{ money(product.price) }}</small>
                    </div>
                    <div class="chip__actions">
                      <button
                        class="ct-btn ct-btn-ghost ct-btn-sm"
                        type="button"
                        (click)="moveProduct(product.productId, 'optional')"
                      >
                        {{ 'bundles.makeRequired' | t }}
                      </button>
                      <button
                        class="ct-btn ct-btn-danger ct-btn-sm"
                        type="button"
                        (click)="removeProduct(product.productId, 'optional')"
                      >
                        {{ 'common.delete' | t }}
                      </button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <div class="section">
          <h3>{{ 'products.attributes' | t }}</h3>
          <p class="hint">{{ 'products.attributesHint' | t }}</p>
          @if (attributeFields().length === 0) {
            <p class="empty">{{ 'products.noAttributes' | t }}</p>
          } @else {
            <div class="ct-form-grid">
              @for (field of attributeFields(); track field.filterId) {
                <div class="ct-field">
                  <label [attr.for]="'attr-' + field.filterId">{{ field.name }}</label>
                  @if (field.valueType === 'Boolean') {
                    <select
                      class="ct-select"
                      [id]="'attr-' + field.filterId"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    >
                      <option value="">—</option>
                      <option value="true">{{ 'common.yes' | t }}</option>
                      <option value="false">{{ 'common.no' | t }}</option>
                    </select>
                  } @else if (field.valueType === 'Options') {
                    <select
                      class="ct-select"
                      [id]="'attr-' + field.filterId"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    >
                      <option value="">—</option>
                      @for (opt of field.options; track opt.value) {
                        <option [value]="opt.value">{{ opt.display }}</option>
                      }
                    </select>
                  } @else {
                    <input
                      class="ct-input"
                      [id]="'attr-' + field.filterId"
                      [type]="field.valueType === 'Number' ? 'number' : 'text'"
                      [step]="field.valueType === 'Number' ? 'any' : null"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    />
                  }
                </div>
              }
            </div>
          }
        </div>

        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
